//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import Faq from '~/components/homepage/Faq'

export default BaseCmsBlock.extend({
  data: function () {
    return {
      opened: [],
    }
  },

  computed: {
    title: function () {
      return this.values?.title || ''
    },
    questions: function () {
      return this.values?.questions || []
    },
  },

  components: {
    Faq
  },

  methods: {
    changeOpened: function (index) {
      let opened = [...this.opened];
      const findIndex = opened.findIndex((t) => t === index);
      if (findIndex > -1) {
        opened.splice(findIndex, 1)
      } else {
        opened.push(index)
      }
      this.opened = opened;
    },
  }
});
